import request from '@/utils/request'

const currentPromotion = () => {
  return request({
    url: `/api/promotion/current`,
    method: 'get'
  })
}

const findPromotion = code => {
  return request({
    url: `/api/promotion/find`,
    method: 'post',
    data: { code }
  })
}

const activatePromotion = code => {
  return request({
    url: `/api/promotion/activate`,
    method: 'post',
    data: { code }
  })
}

export default {
  currentPromotion,
  findPromotion,
  activatePromotion
}
